export default "__VITE_ASSET__CgaddZ2z__"